<template>
  <section class="container-fluid section-styles">
    <div class="quote-wrapper">
      <div class="quote">
        <img src="../../../assets/quote.svg" class="quotation-mark" alt="" />
        {{ quote }}
      </div>
    </div>
  </section>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
class Quote extends Vue {
  @Prop({
    type: String,
  })
  quote;
}

export default Quote;
</script>
<style scoped>
.section-styles {
  background-color: #e2eef0;
  width: 100vw;
  padding: 7rem 2rem 7rem 2rem;
  margin-top: 5rem;
}
.quote-wrapper {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  text-align: center;
  @media only screen and (min-width: 998px) {
    flex-direction: row;
    justify-content: center;
  }
}
.quote {
  max-width: 45rem;
  margin: 0 auto;
  font-size: 3.75rem;
  font-family: 'klinicslabbold';
  color: #41666b !important;
  position: relative;
  line-height: 74.4px;
  @media only screen and (max-width: 998px) {
    font-size: 3.25rem;
    line-height: 62.4px;
  }
}
.quotation-mark {
  position: absolute;
  color: #6daab2;
  left: -10rem;
  top: 0;
  height: 5rem;
  width: min-content;

  @media only screen and (max-width: 998px) {
    top: -4rem;
    left: 0;
    height: 3.4rem;
  }
}
</style>
